import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import {
  createArea,
  fetchAllAreas,
  updateArea,
  fetchOneArea,
  deleteArea,
} from "services/area";

export const useAllAreas = (filters = {}, enabled = true) => {
  return useQuery({
    queryKey: ["areas", filters],
    queryFn: () => fetchAllAreas(filters),
    enabled,
  });
};

export const useOneArea = (id, enabled = true) => {
  return useQuery({
    queryKey: ["area", id],
    queryFn: () => fetchOneArea(id),
    enabled: Boolean(id) && enabled,
  });
};

export const useCreateArea = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data) => createArea(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["areas"] });
    },
  });
};

export const useUpdateArea = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }) => updateArea(data, id),
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries({ queryKey: ["areas"] });
      queryClient.invalidateQueries({ queryKey: ["area", variables.id] });
    },
  });
};

export const useDeleteArea = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id) => deleteArea(id),
    onSuccess: (data, id) => {
      queryClient.invalidateQueries({ queryKey: ["areas"] });
      queryClient.invalidateQueries({ queryKey: ["area", id] });
    },
  });
};
